// extracted by mini-css-extract-plugin
module.exports = {"modal-header":"HideStatsInfo--modal-header--3fXDk","modalHeader":"HideStatsInfo--modal-header--3fXDk"};